import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import ProductsOverview from './components/ProductsOverview';
import ProductFinder from './components/ProductFinder';
import { SeoSectionOne, SeoSectionTwo } from './components/SeoSections';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import GuidePage from './pages/GuidePage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './index.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function HomePage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    const revealOnScroll = () => {
      reveals.forEach((reveal) => {
        const elementTop = reveal.getBoundingClientRect().top;
        if (elementTop < window.innerHeight - 100) reveal.classList.add('active');
      });
    };
    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();

    const smoothScroll = (e) => {
      const targetId = e.currentTarget.getAttribute('href');
      if (targetId && targetId !== '#' && targetId.startsWith('#')) {
        const el = document.querySelector(targetId);
        if (el) {
          e.preventDefault();
          const offset = el.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
      }
    };
    document.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', smoothScroll));

    return () => {
      window.removeEventListener('scroll', revealOnScroll);
      document.querySelectorAll('a[href^="#"]').forEach(a => a.removeEventListener('click', smoothScroll));
    };
  }, []);

  return (
    <main>
      <Helmet>
        <title>NetTest Testere | Endüstriyel Şerit Testere ve Kesici Uçlar</title>
        <meta name="description" content="Endüstriyel şerit testere bıçakları, bimetal ve karbür çözümleri. Kesim maliyetlerinizi düşüren yüksek performanslı testereler." />
        <link rel="canonical" href="https://nettesttestere.com/" />
      </Helmet>
      <Hero />
      <ProductFinder />
      <ProductsOverview />
      <SeoSectionOne />
      <About />
      <Services />
      <Contact />
    </main>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/urunler/:categoryId" element={<CategoryPage />} />
        <Route path="/urunler/:categoryId/:productId" element={<ProductPage />} />
        <Route path="/serit-testere-secimi" element={<GuidePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        
        {/* SEO-friendly Category Landing Pages */}
        <Route path="/bimetal-serit-testere" element={<CategoryPage forcedCategory="bimetal" />} />
        <Route path="/karbur-serit-testere" element={<CategoryPage forcedCategory="karbur" />} />
        <Route path="/elmas-cbn-testere" element={<CategoryPage forcedCategory="elmas-cbn" />} />
        <Route path="/karbon-serit-testere" element={<CategoryPage forcedCategory="karbon" />} />
        <Route path="/daire-testere" element={<CategoryPage forcedCategory="daire-testere" />} />
      </Routes>
      <Footer />
      <a href="https://wa.me/905470013478" className="floating-whatsapp" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp ile iletişime geçin">
        <i className="fa-brands fa-whatsapp"></i>
      </a>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
